/** Port von `Pages/Auth/AuthErrorNoApp.razor`. */

import type { ReactElement } from 'react';
import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAuth } from '@/auth/useAuth';
import { Button } from '@/components/ui';

export function ErrorNoApps(): ReactElement {
  const auth = useAuth();
  const navigate = useNavigate();
  const initialized = useRef(false);

  useEffect(() => {
    if (initialized.current) {
      return;
    }
    initialized.current = true;

    const loadApps = async (): Promise<void> => {
      try {
        const apps = await auth.loadApps();
        if (apps.length > 0) {
          void navigate('/authentication/apps');
        }
      } catch {
        // `AuthErrorNoApp.razor` wertet Fehler nicht aus; die Seite bleibt dann stehen.
      }
    };
    void loadApps();
  }, [auth, navigate]);

  const logout = async (): Promise<void> => {
    await auth.logout();
    void navigate('/authentication/logout');
  };

  return (
    <div className="iwm-card">
      <h3>Fehler</h3>
      <span>Ihrem Konto wurden noch keine Applikationen zugewiesen.</span>
      <div style={{ marginTop: '1rem' }}>
        <Button primary onClick={logout}>
          Ausloggen
        </Button>
      </div>
    </div>
  );
}

export default ErrorNoApps;
